<template lang="html">
  <div class="map-main">
    <div class="map-warpper">
      <div class="map-content">
        <div class="add-map" @click="handleAddMap">
          <img src="../../assets/views/map/add-map.png">
          新建地图
        </div>
        <div class="map">
          <div v-for="(item, index) in mapData" :key="index" class="map-item">
            <div class="map-item__thumb map-item-thumb">
              <img class="map-item-thumb__image" :src="item.preview_img">
              <div class="map-item-thumb__coverone" v-if="!item.store_id">
                <img src="../../assets/views/map/edit-background.png" alt="">
              </div>
              <div class="map-item-thumb__cover">
                <AiImageButton class="map-item-thumb__button"
                               :idle="icons.edit.idle"
                               :pressed="icons.edit.pressed"
                               @click="downloadModel(item)" />
                <AiImageButton class="model-item-thumb__button"
                               :idle="icons.remove.idle"
                               :pressed="icons.remove.pressed"
                               @click="deleteModel(item)" />
              </div>
            </div>
            <div class="map-item__title">{{ item.map_name }}</div>
            <div class="map-item__sub">{{ item.create_time}}</div>
          </div>
        </div>
      </div>
      <AiPagination v-model="currentPage"
                    class="pagination"
                    :total-page-count="totalPageCount"
                    @change="pages" />
      <addMapDialog
        v-show="dialogShow"
        @closeDialog="dialogShow=false"
        @newMap="newMap"
        ref="addMap">
        <template v-slot:header>
          <header>地图名称</header>
        </template>
        <template v-slot:content>
          <input type="text" v-model="inputValue">
        </template>
      </addMapDialog>
      <addMapDialog
        v-show="deleteDialogShow"
        ref="delete"
        @newMap="deleteModelSubmit()"
        @closeDialog="deleteCloseDialog">
        <template v-slot:header>
          <img src="../../assets/views/map/delete-warning.png" class="message-icon">
        </template>
        <template v-slot:content>
          <div class="message delete-msg">
            确认删除该地图所有数据？
          </div>
        </template>
      </addMapDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import addMapDialog from '@/components/editor/add-map-dialog.vue';
const ICON_EDIT = require('@/assets/views/map/edit.png');
const ICON_EDIT_PRESSED = require('@/assets/views/map/edit-selected.png');
const ICON_REMOVE = require('@/assets/views/models/remove.svg');
const ICON_REMOVE_PRESSED = require('@/assets/views/models/remove-selected.svg');

export default {
  data() {
    return {
      dialogShow: false,
      inputValue: '',
      httpAxios: axios.create({}),
      // 地图列表
      mapData: [],
      icons: {
        edit: { idle: ICON_EDIT, pressed: ICON_EDIT_PRESSED },
        remove: { idle: ICON_REMOVE, pressed: ICON_REMOVE_PRESSED }
      },
      currentPage: 1,
      totalPageCount: 20,
      deteteMapId: '',
      deleteDialogShow: false

    };
  },
  components: {
    addMapDialog
  },
  created() {
    this.pages();
  },
  methods: {
    handleAddMap() {
      this.dialogShow = true;
    },
    async newMap() {
      if (!this.inputValue) return;
      this.dialogShow = false;
      const params = {
        map_name: this.inputValue
      };
      try {
        const { data } = await this.$http.post(
          '/navigation/create',
          params
        );
        if (data.retcode === 0) {
          this.$router.push(`/x/map/${data.data.map_id}/editor/vr-compose?store_id=create`);
          this.$store.commit('getMapId', data.data.map_id);
          this.$store.commit('getMaterFlag', 'false');
          this.$store.commit('getChildFlag', 'false');
          this.$store.commit('getMergeFlag', 'false');
          this.$store.commit('getChildStoreId', '');
          this.$store.commit('getCADUrl', '');
          this.$log('this.$store.state.mergeFlag index')
          this.inputValue = '';
        }
      } catch (error) {
        this.$log(error);
      }
    },
    async pages() {
      const params = {
        page_num: this.currentPage
      };
      try {
        const { data } = await this.$http.post(
          '/navigation/page',
          params
        );
        if (data.retcode === 0) {
          this.mapData = data.data.maps;
          this.currentPage = data.data.page_num;
          this.totalPageCount = data.data.page_count;
          this.$log(this.totalPageCount)
        }
      } catch (error) {
        this.$log(error);
      }
    },
    deleteModel(item) {
      this.deleteDialogShow = true;
      this.deteteMapId = item.map_id;
      this.$refs.delete.deleteButton = true;
      this.$refs.delete.buttonDisabled = false;
    },
    async deleteModelSubmit() {
      const params = { map_id: this.deteteMapId };
      try {
        const { data } = await this.$http.post(
          '/navigation/delete',
          params
        );
        if (data.retcode === 0) {
          this.deleteDialogShow = false;
          this.$refs.delete.deleteButton = false;
          this.$refs.delete.buttonDisabled = true;
          this.pages();
        }
      } catch (error) {
        this.$log(error);
      }
    },
    downloadModel(item) {
      console.log(item)
      // this.$router.push(`/x/map/${item.map_id}/editor/cad-alignmet?store_id=${item.store_id}`);
      // this.$router.push(`/x/map/${item.map_id}/editor/vr-compose?store_id=create`);
      this.$router.push(`/x/map/${item.map_id}/editor/vr-compose?store_id=${item.store_id}`);
      this.$store.commit('getStoreId', item.store_id);
      item.store_id ? this.$store.commit('getMaterFlag', 'true') : this.$store.commit('getMaterFlag', 'false');
      this.$store.commit('getChildFlag', 'false');
      item.is_merged ? this.$store.commit('getMergeFlag', 'true') : this.$store.commit('getMergeFlag', 'false');
      // this.$store.commit('getMergeFlag', 'true');
      this.$store.commit('getMapId', item.map_id);
      this.$store.commit('getCADUrl', '');
      //  console.log('this.$store.state.mapId' + this.$store.state.mapId);
    },
    deleteCloseDialog() {
      this.deleteDialogShow = false;
      this.$refs.delete.deleteButton = false;
      this.$refs.delete.buttonDisabled = true;
    }
  },
  watch: {
    inputValue(val) {
      if (!val) {
        this.$refs.addMap.buttonDisabled = true;
      } else {
        this.$refs.addMap.buttonDisabled = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .map-main{
    width: 100%;
    background-color: #000;
    .map-warpper {
      background-color: #000;
      width: 100%;
      position: relative;

      .map-content {
        width: 1280px;
        margin: 0 auto;
        padding: 40px 0 51px 0;
        background-color: #000;

        .add-map {
          border: 1px solid #08CE82;
          width: 86px;
          border-radius: 4px;
          padding: 9px 17px;
          font-size: 16px;
          color: #08CE82;
          margin-left: 40px;
        }
      }
      .map {
        display: grid;
        grid-template-columns: repeat(4, 320px);
        grid-template-rows: auto;
      }

      .map-item {
        margin: 20px 40px;
        color: #888;

        &__thumb {
          width: 240px;
          height: 200px;
          background-color: #e0e0e0;
          border-radius: 4px;
          position: relative;
        }

        &__title {
          font-size: 18px;
          margin: 6px 0 2px;
        }

        &__sub {
          font-size: 14px;
          font-weight: 300;
          margin: 2px 0;
        }
      }

      .map-item-thumb {
        &__image {
          width: 240px;
          height: 200px;
          border-radius: 4px;
          object-fit: cover;
        }

        &__cover {
          position: absolute;
          display: grid;
          width: 232px;
          height: 196px;
          top: 0;
          left: 0;
          padding: 2px 4px;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, .6);
          grid-template-columns: 50% 50%;
          justify-items: center;
          align-items: center;
          opacity: 0;
          transition: .15s;

          &:hover {
            /*opacity: 1;*/
          }
        }
        &__coverone {
          position: absolute;
          width: 232px;
          height: 196px;
          top: 0;
          left: 0;
          padding: 2px 4px;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, .6);
          display: flex;
          justify-items: center;
          align-items: center;
          opacity: 0;
          transition: .15s;
          img{
            width: 80px;
            height: 80px;
            margin: 0 auto;
          }
          &:hover {
            /*opacity: 1;*/
          }
        }
        &:hover{
          .map-item-thumb__cover{
            z-index: 20;
            opacity: 1;
          }
          .map-item-thumb__coverone{
            opacity: 0.7;
          }
        }

        &__button {
          width: 40px;
          height: 40px;
        }
      }
      .pagination {
        width: 100%;
        margin: 8px 0 38px;
      }
    }
  }
</style>
